import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import "../../components/Modals/Step.css"
import { connect } from "react-redux";
import close from "../../assets/svgs/close.svg";
import logout from "../../assets/svgs/log-out.svg";
import "../../assets/css/modal.css";
import { useHistory } from "react-router-dom";
import { propTypes } from "react-bootstrap/esm/Image";
import { loginUser } from "../../actions/authActions";

const SignupComplete = ({ show, closeModal, business_id, location_id, joinus, signup_login, user_name, loginUser, tempSignupResults }) => {
  const history = useHistory();
  const handleLogin = () => {
    closeModal();
    if (joinus) {
      window.location.href = "/?business_id=" + business_id + "&location_id=" + location_id
    } else if (business_id && location_id) {
      history.push("/?business_id=" + business_id + "&location_id=" + location_id);
    } else {
      history.push("/?business_id=" + localStorage.business_id + "&location_id=" + localStorage.location_id);
    }

    // console.log(signup_login, 'signup_loginwertywertyu')
    // if (signup_login) {
    //   const userData = {
    //     email: signup_login.user.email,
    //     password: tempSignupResults?.password || "test123",
    //     platform: "Food-Delivery",
    //     business_id: business_id,
    //     username: user_name
    //   }
    //   loginUser(userData, true, "register");
    // }
  }

  return (
    <Modal
      show={show}
      onHide={() => closeModal}
      dialogClassName="modal-smd maxwidth500"
      centered
    >
      <Modal.Body className="p-2">
        <div className="modal-body d-flex justify-content-center align-items-end">
          <button
            type="button"
            className="close-modal-btn"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              if (joinus) {
                window.location.href = "/?business_id=" + business_id + "&location_id=" + location_id
              } else {
                closeModal()
              }
            }}
          >
            <img src={close} width="20" alt="close" />
          </button>
          <div className="text-center" style={{ marginTop: '5vh' }}>
            <div className="f40 claim">
              <h1>GREAT!</h1>
            </div>
            <p>Your account has been created successfully. Thank you for choosing to dine with us!.</p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer no">
        <button
          type="button"
          className="btn btn-danger claim-button btn-block py-0"
          data-dismiss="modal"
          onClick={() => {
            handleLogin();
            // if (joinus) {
            //   window.location.href = "/?business_id=" + business_id + "&location_id=" + location_id
            // } else {
            //   history.push("/?business_id=" + localStorage.business_id + "&location_id=" + localStorage.location_id);
            // }
          }}
        >
          START ORDERING NOW!
        </button>
        <div style={{ width: '100%', fontSize: '10pt' }}>
          <p>Powered by Warely</p>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  tempSignupResults: state?.user?.tempSignup
});

export default connect(mapStateToProps, { loginUser })(SignupComplete);